import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7c85fe75")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Are you sure?", -1)
const _hoisted_2 = {
  key: 0,
  class: "functions"
}
const _hoisted_3 = { key: 1 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: "overlay",
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reject()))
  }, [
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
      class: _normalizeClass({
      confirmPopup:true,
    })
    }, [
      _hoisted_1,
      _createElementVNode("p", null, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      (!_ctx.pending)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_IconButton, {
              white: true,
              text: "Cancel",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reject()))
            }),
            _createVNode(_component_IconButton, {
              text: _ctx.text||'Yes',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resolve()))
            }, null, 8, ["text"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_LoadSpinner, { text: "Please wait" })
          ]))
    ])
  ]))
}